/**
 * Definition of all generic states
 */

window.GenericStates = {
    beforeLoaderClose: {
        name: "BeforeLoaderClose",
        execute: function() {
            // Stub.
        },
        waitEvents: {}
    },

    setupGame: {
        name: "SetupGame",
        execute: function() {
            // Stub.
        },
        waitEvents: {}
    },

    idle: {
        name: "Idle",
        execute: function(env) {
            // Stub.
        },
        waitEvents: {}
    }
};
